import type { TFunction } from 'i18next';

import type { IApiAppUserRole } from '~/lib/api/modules/Apps';

export const getAppRoleLabel = (
  role: IApiAppUserRole,
  t: TFunction<'translation', undefined>,
): string => {
  switch (role) {
    case 'viewer':
      return t('AppRoleSelector.viewer.label');
    case 'editor':
      return t('AppRoleSelector.editor.label');
    case 'moderator':
      return t('AppRoleSelector.moderator.label');
    case 'admin':
      return t('AppRoleSelector.admin.label');
  }
};
